import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotificationModel } from '../../shared/models/notification.model';

@Component({
  selector: 'sp-user-notifications-display',
  standalone: false,
  templateUrl: './user-notifications-display.component.html',
  styleUrl: './user-notifications-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationsDisplayComponent {

  @Input() userNotifications: NotificationModel[] = [];  

}
